<ng-template #adobePdfModal>
    <div class="modal-header">
        <h2 class="modal-title m-0">{{document?.description}}</h2>
        <button type="button" class="btn-close" aria-label="Close" (click)="modalRef?.close()">
        </button>
    </div>
    <div class="modal-body">
        @if (annotations && annotations.length) {

        @if (annotations.length < 5) {
        <div class="row">
            @if (annotations && annotations.length) {
            <div id="annotations" class="col form-inline">
                <div class="btn-group btn-group-toggle">
                    @for (annotation of annotations; track annotation; let i = $index) {
                    <label class="btn btn-outline-primary mb-0 mr-0" [class.active]="i === chosenAnnotation" (click)="gotoPage(annotation.target.selector.node.index, i)">
                        <input type="radio" name="annotation" id="{{ annotation + i }}" [checked]="i === chosenAnnotation" class="btn-check">
                        {{ annotation.bodyValue }}
                    </label>
                    }
                </div>
            </div>
            }
        </div>
    }
    @if (annotations.length >= 5) {
        <div class="row">
            <div class="col">
                <div class="form-group row mb-1">
                    <label class="col-form-label form-control-lg">Show: </label>
                    <div class="col">
                        <select class="form-select-lg" (ngModelChange)="gotoPageViaSelect($event)" [ngModel]="chosenAnnotationIndex">
                            @for (annotation of annotations; track annotation) {
                            <option [ngValue]="annotation.target.selector.node.index">
                                {{ annotation.bodyValue }}
                            </option>
                            }
                        </select>
                    </div>
                </div>
            </div>
        </div>
    }

    }
    @if (searchTerm.length) {
        <div class="row">
            <div class="col">
                <div class="input-group">
                    <div class="input-group-text" id="btnGroupAddon">
                        Search:
                        @if (searchCallbackValue && searchCallbackValue.totalResults > 0) {
                        <span>
                            {{ searchCallbackValue.currentResult.index }} of {{ searchCallbackValue.totalResults }}
                        </span>
                        }
                    </div>
                    <input type="text" class="form-control" [(ngModel)]="searchTerm" (ngModelChange)="changeSearch()">
                    <button type="button" class="btn btn-outline-secondary" [disabled]="searchCallbackValue?.currentResult?.index === 1" (click)="previousSearchResult()"><i-bs [name]="iconNames.CaretUp"></i-bs></button>
                    <button type="button" class="btn btn-outline-secondary" [disabled]="searchCallbackValue?.currentResult?.index === searchCallbackValue?.totalResults" (click)="nextSearchResult()"><i-bs [name]="iconNames.CaretDown"></i-bs></button>
                </div>
            </div>
        </div>
    }
        <div class="row">
            <div id="pdf-div" class="col pdf-view">
                @if (usingFallbackViewer) {
                    <ngx-extended-pdf-viewer [src]="pdfToView"></ngx-extended-pdf-viewer>
                }
            </div>
        </div>
    </div>
</ng-template>